import ExternalLink from 'components/ExternalLink/ExternalLink.component';
import Icon from 'components/Icon/Icon.component';
import colors from 'style-utils/colors';
import createExtractCssFromProps from 'style-utils/createExtractCssFromProps';
import { withMargin, withPadding } from 'style-utils/dimensionsMixins';
import media from 'style-utils/media-queries';
import { withOneLineEllipsis } from 'style-utils/overflow';
import styled, { css, StyledProps } from 'styled-components';
import { ToolbarButtonProps } from '../SignedInUserToolbar.type';

const mobilePanelShadow = '0px 4px 16px 0px #0000001F inset';
const desktopPanelShadow = 'inset 0 8px 16px rgba(0, 0, 0, 0.08)';

export const Notifications = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  flex: 1 1 auto;
  overflow: hidden;
  color: ${colors.blackTwelve};
  letter-spacing: 0.2px;
`;

export const NotificationLabel = styled.span`
  display: inline-block;
  width: 100%;
  font-size: 12px;
  letter-spacing: inherit;
  color: ${colors.white};
  ${withOneLineEllipsis};
  ${createExtractCssFromProps({ textAlign: 'text-align' })};
`;
NotificationLabel.defaultProps = {
  textAlign: 'left',
};

export const CurrencyLabel = styled.span`
  display: inline-block;
  width: 100%;
  letter-spacing: inherit;
  font-size: 12px;
  flex: 0 0 auto;
  font-weight: bold;
  text-align: left;
  color: ${colors.white};
  ${withOneLineEllipsis};
`;

const notificationSectionStyles = css`
  display: flex;
  overflow: hidden;
  max-width: 120px;
  height: 100%;
  flex-flow: column nowrap;
  justify-content: center;
  color: inherit;
  flex: 0 1 auto;
  text-decoration: none;
  margin: 0;
  & > * {
    flex: 0 0 auto;
  }
`;

export const VerticalSeparator = styled.div`
  width: 1px;
  background-color: ${colors.white};
  margin: 0 12px 0 0;
`;

export const BonusLink = styled(ExternalLink)`
  ${notificationSectionStyles};
`;

export const BalanceDisplay = styled.div`
  ${notificationSectionStyles};
  padding: 0 8px 0 0;
`;

export const UserWallet = styled.div`
  display: flex;
  padding: 7px 8px;
  border-radius: 8px;
  margin-right: 8px;
  border: 1px solid var(--component-button-color-primary-border-default);

  ${media.desktop`
    padding: 8px;
    margin: 0 12px 0 4px;
  `}
`;

export const VericalRuler = styled.hr`
  height: 19.5px;
  width: 1px;
  background: currentColor;
  border: none;
  padding: 0;
  flex: 0 0 auto;
  margin: 0 11.5px;
`;

export const ToolbarButton = styled.button<StyledProps<ToolbarButtonProps>>`
  display: inline-block;
  line-height: 1;
  margin: 0;
  border: none;
  outline: none;
  cursor: pointer;
  color: inherit;
  ${withPadding};
  ${withMargin};
  color: ${colors.white};
  background: ${colors.transparent};
`;
ToolbarButton.defaultProps = {
  padding: '0',
};

export const Panel = styled.div`
  position: fixed;
  top: 4, 3%;
  right: 0;
  left: unset;
  margin: auto;
  width: 100%;
  background: white;
  color: black;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: none;
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: ${mobilePanelShadow};
    pointer-events: none;
    z-index: 1;
  }
  z-index: 1002;
  ${media.desktop`
    max-width: 360px;
    right: 16px;
    box-shadow: ${desktopPanelShadow};
    &::after {
      content: none;
    }
  `}
`;

export const WalletRow = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
`;

export const TransactionsRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 16px 12px;

  > button {
    height: 36px;
  }
`;

export const BonusComponent = styled.div`
  display: block;
  width: 100%;
`;

export const Separator = styled.div`
  width: 12px;
  flex: 0 0 12px;
`;

////////////////// DROPDOWN //////////////////////

export const DropdownChevron = styled.button<StyledProps<ToolbarButtonProps>>`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 24px;
  height: 24px;
  margin: 0 0 0 8px;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  color: inherit;
  background: ${colors.transparent};
  flex-shrink: 0;

  & > div {
    display: inline-flex;
  }
`;

export const DropdownTitle = styled.div`
  font-family: var(--secondary-font-family), sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  ${media.desktop`
    font-size: 18px;
    font-weight: 800;
    line-height: 20px;
  `}
`;

export const IconAlertCard = styled(Icon)`
  cursor: pointer;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;
